<template>
  <div class="screen-time">
    <header-mobile-page v-if="$mq === 'mobile'"
                        :label="child.name" />

    <screen-time-management :childId="childId"
                            :show="true" />
  </div>
</template>

<script>
  import ScreenTimeManagement from '@/components/Child/ChildScreenTime/ScreenTimeManagement'
  import HeaderMobilePage from '@/components/Header/HeaderMobilePage'

  export default {
    components: {
      ScreenTimeManagement,
      HeaderMobilePage
    },

    props: {
      childId: {
        type: String,
        required: true
      }
    },

    computed: {
      ...mapGetters('children', {
        getChildById: 'getById'
      }),

      child() {
        return this.getChildById(this.childId)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .screen-time {
    width: 100%;
    height: auto;

    padding: 0 20px 10px 20px;
  }
</style>